import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateInfluencerRpcContract = rpcContract({
  name: "updateInfluencer",
  paramsSchema: v.object({
    influencerId: v.string(),
    handle: v.pipe(
      v.string(),
      v.minLength(3, "Handle must be at least 3 characters"),
      v.maxLength(64, "Handle must be at most 64 characters"),
      v.regex(/^[a-z0-9_\-.]+$/, "Handle can only contain lowercase letters, numbers, underscores, dots, and hyphens"),
    ),
    email: v.pipe(v.string(), v.email("Please enter a valid email address")),
    isActive: v.boolean(),
    isStaff: v.boolean(),
    paidLiveEvents: v.optional(v.boolean()),
    openLiveEvents: v.optional(v.boolean()),
    subscription: v.optional(v.boolean()),
    oneTimePurchase: v.optional(v.boolean()),
    liveEventBackgroundImages: v.optional(v.boolean()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.string(),
  }),
});

export type UpdateInfluencerParams = v.InferOutput<(typeof updateInfluencerRpcContract)["paramsSchema"]>;
export type UpdateInfluencerResult = v.InferOutput<(typeof updateInfluencerRpcContract)["resultSchema"]>;
